export default __webpack_public_path__ + "static/media/kitchen-compressed.771ffe3a.jpg";